import styled from "styled-components";


interface Props {
    icon: React.ReactNode;
    iconSize: string;
    backgroundColor: string;
    color: string;
    size: string;
    style?: any;
    method: () => void;
}

const Wrapper = styled.nav<any>`
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 1.2px 1px 2px var(--black_shadow_1);
    background-color: ${props => props.backgroundColor};
    font-size: ${props => props.iconSize};;
    width: ${props => props.size};;
    height: ${props => props.size};;
    border-radius: 50px;
    transition: .3s all;
    cursor: pointer;

    color: ${props => props.color};

    :hover {
        transform: scale(1.1);
    }

    :active {
        opacity: 0.6;
    }
`;


const FloatingBottom = ({ icon, iconSize, backgroundColor, color, size, style, method }: Props) => (
    <Wrapper
        iconSize={iconSize}
        backgroundColor={backgroundColor}
        color={color}
        size={size}
        style={style}
        onClick={method}
    >
        {icon}
    </Wrapper>
)


export default FloatingBottom;